import * as React from 'react'
import {Dialog, Button} from 'startlibs/lib/components'
import {withDialogError} from 'startlibs/lib/hocs'

@withDialogError
export class ConfirmLeaveDialog extends React.Component {

  render() {
    const {closeDialog, save, discard, isLoading} = this.props
    return (<Dialog
      closeDialog={closeDialog}
      onConfirm={save}
      className="confirm-close-dialog"
      title="Your changes won't be saved"
    >
      <Dialog.Content>
        <div>
          <p>The changes made in this screen were not saved. Would you like to quit anyway?</p>
        </div>
      </Dialog.Content>
      <Dialog.Footer>
        <Button onClick={closeDialog}>Cancel</Button>
        <Button onClick={save} isLoading={isLoading} success={isLoading} hover="success">Save changes</Button>
        <Button type="submit" onClick={discard} alert>Discard changes</Button>
      </Dialog.Footer>
    </Dialog>)
  }
}



// WEBPACK FOOTER //
// ./src/javascripts/components/ConfirmLeaveDialog.jsx